{
  "version": 1,
  "asset_id": "1581db42-c3d6-45a5-8574-5090febe7231",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/1581db42-c3d6-45a5-8574-5090febe7231/stamped-concrete-final.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/1581db42-c3d6-45a5-8574-5090febe7231/stamped-concrete-final.webp",
  "original_filename": "stamped-concrete-final.webp",
  "size": 580902,
  "content_type": "image/webp",
  "created_at": "2026-09-11T23:20:39Z"
}
